import styles from "./PaginationSkeleton.module.scss";

const PaginationSkeleton: React.FC = () => {
  return (
    <div className={styles.paginationWrap}>
      <div className={styles.content}>
        <div className={`${styles.text} skeleton`} />

        <div className={styles.limit}>
          <div className={`${styles.limitInner} skeleton`} />
        </div>
      </div>

      <div className={styles.arrows}>
        <div className={`${styles.arrow} skeleton`} />
        <div className={`${styles.arrow} skeleton`} />
      </div>
    </div>
  );
};

export default PaginationSkeleton;
